/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BehaviorResponse } from '../models/behavior-response';
import { recordClick } from '../fn/behavior/record-click';
import { RecordClick$Params } from '../fn/behavior/record-click';


/**
 * Behavior API
 */
@Injectable({ providedIn: 'root' })
export class BehaviorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `recordClick()` */
  static readonly RecordClickPath = '/api/behavior/click';

  /**
   * Record click behavior.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recordClick()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recordClick$Response(params: RecordClick$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorResponse>> {
    return recordClick(this.http, this.rootUrl, params, context);
  }

  /**
   * Record click behavior.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recordClick$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recordClick(params: RecordClick$Params, context?: HttpContext): Observable<BehaviorResponse> {
    return this.recordClick$Response(params, context).pipe(
      map((r: StrictHttpResponse<BehaviorResponse>): BehaviorResponse => r.body)
    );
  }

}
